// Cariyi Borçlandır penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.debit';

export const accountDebitGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Cari nasıl borçlandırılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, cariye fatura kesmeden cari hesaba borç (tahakkuk) hareketi işler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve cari'),
    body: t(`${G}.regions.body`, 'Borçlandırma formu'),
    footer: t(`${G}.regions.footer`, 'Borçlandır'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Faturasız bir borcu (tahakkuk) cariye yazmak için kullanılır. Üstteki kartta carinin adı ve güncel bakiyesi görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kasa ve banka etkilenmez'),
      text: t(`${G}.s2.text`, 'Borçlandırma kasa veya banka bakiyesini DEĞİŞTİRMEZ; yalnızca carinin borç bakiyesini artıran bir hareket kaydı oluşturur. Bu yüzden formda kasa veya banka seçimi yoktur.'),
      tips: [
        t(`${G}.s2.tip1`, 'Paranın gerçekten el değiştirdiği durumlar için "Cariden Tahsilat" veya "Cariye Ödeme Yap" kullanın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Formu doldurun'),
      text: t(`${G}.s3.text`, 'Para birimi, işlem tarihi, belge numarası ve tutar zorunludur. Tarih varsayılan olarak bugündür, ileri veya geri tarih verebilirsiniz. Belge numarası otomatik gelir (BRC-…), dilerseniz değiştirin. Tutarı 1.000,00 biçiminde girin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Seçilen tarih bugünden 30 günden fazla uzaksa kaydetmeden önce onay istenir.'),
        t(`${G}.s3.tip2`, 'Şube boş bırakılırsa ("Genel") hareket carinin şubesine yazılır.'),
        t(`${G}.s3.tip3`, 'Açıklama ve proje bağlantısı isteğe bağlıdır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Cariyi borçlandırın'),
      text: t(`${G}.s4.text`, '"Cariyi Borçlandır" düğmesi zorunlu alanlar dolunca açılır. Kayıttan sonra carinin borcu girdiğiniz tutar kadar artar. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
